<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div id="searchApp">
                    <div id="search-box-index">
                        <div class="search-box">
                            <el-autocomplete ref="autocomplete" @keydown.enter.native="handleEnterSearch"
                                prefix-icon="el-icon-search" :fetch-suggestions="querySearchAsync"
                                :trigger-on-focus="false" placeholder="输入关键词" v-model="searchValue"
                                class="input-with-select" value-key="label">
                                <template slot-scope="{ item }">
                                    <a :href="item.url" class="custom-template" v-html="item.value"></a>
                                </template>
                                <div slot="prepend" v-if="!isMobile">
                                    <el-select v-model="typeValue" placeholder="">
                                        <el-option v-for="type in searchTypeList" :label="type.name" :value="type.id"
                                            :key="type.id"></el-option>
                                    </el-select>
                                    <div class="search-line"></div>
                                </div>
                                <div style="height: 100%; display: flex; align-items: baseline" slot="suffix">
                                    <span v-if="searchValue" @click="searchValue = ''">
                                        <i class="el-icon-error search-clean-icon"></i>
                                    </span>
                                    <a href="javascript:;" @click.stop="handleEnterSearch" class="my-search-btn">搜索</a>
                                </div>
                            </el-autocomplete>
                        </div>
                    </div>
                    <section class="section1">
                        <h2 class="">相关文章</h2>
                        <section class="section1">
                            <div class="knowledge-list" v-loading="loading">

                                <div class="knowledge-item" v-for="item in list" :key="item.id">
                                    <a :href="item.url.replace('/zh-cn', '')">
                                        <img class="knowledge-item-img" :src="image_pre + item.thumbnail"
                                            :alt="item.post_title" />
                                    </a>
                                    <div class="knowledge-item-content">
                                        <a :href="item.url.replace('/zh-cn', '')" class="knowledge-item-title">{{
                                            item.title }}</a>
                                        <div class="knowledge-item-publish-time">
                                            {{ formateTime(item.published_time) }}
                                        </div>
                                        <div class="knowledge-item-intro">{{ item.excerpt }}</div>
                                    </div>
                                </div>
                                <!-- 加载状态提示 -->
                                <div v-if="loading && list.length > 0" class="load-more-tip">加载中...</div>
                                <div v-if="!hasMore && list.length > 0" class="load-more-tip">没有更多内容了</div>
                            </div>
                        </section>
                        <!-- <div class="search-result-wrapper">
                            <a :href="article.url" class="search-result-card" v-for="article in articles"
                                :key="article.id">
                                <div class="search-result-card-img-box">
                                    <img class="search-result-card-img" :src="image_pre + article.thumbnail" alt="" />
                                </div>
                                <div class="search-result-card-content">
                                    <h3 class="search-result-card-title" v-html="article.title"></h3>
                                    <p class="search-result-card-date">
                                        {{ article.relative_time }}
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="no-data" v-if="total == 0 && !loading">
                            <img class="no-data-img" src="/ebc-static/image/forex/no_data.png" alt="" />
                        </div>
                        <div class="ebc-page-pagination">
                            <el-pagination layout="prev, pager, next" :total="total" :current-page="page"
                                :page-size="pageSize" :pager-count="5" hide-on-single-page
                                @current-change="handleCurrentChange">
                            </el-pagination>
                        </div> -->
                    </section>
                </div>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
    import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getSearchSuggestions, getSearchResults } from '../../serve/forex.js';
let searchTypeList = [
    { id: "all", name: "全部", parent_id: 0, children: [] },
    { id: 142, name: "交易词典", parent_id: 0, children: [] },
    { id: 4, name: "金融知识", parent_id: 0, children: [] },
    { id: 143, name: "市场传奇", parent_id: 0, children: [] },
    { id: 8, name: "金融焦点", parent_id: 0, children: [] },
    { id: 7, name: "数据报告", parent_id: 0, children: [] },
    { id: 146, name: "市场期刊", parent_id: 0, children: [] },
];
let lang = "zh-cn";
const words = [
    '外汇', '保证金', '炒汇', '炒币', 'CFD', '差价合约',
    '虚拟货币', '加密货币', '数字货币', '比特币', 'BTC',
    '以太坊', 'ETH', '台湾', '出金', '入金', '现货'
];

export default {
    components: {
        forexMenu
    },
    data() {
        return {
            searchValue: "",
            typeValue: "all",
            searchTypeList: searchTypeList,
            isMobile: false,
            articles: [],
            list: [],
            total: 0,
            pageSize: 16,
            page: 1,
            image_pre: "https://ebc.site/upload/",
            loading: false, // 是否正在加载
            hasMore: true, // 是否还有更多数据
            isInit: true   // 首次加载标识（避免 scroll 事件触发初始加载）
        };
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        this.searchValue = params.get("word") ? params.get("word") : "";
        this.searchValueCopy = params.get("word") ? params.get("word") : "";
        this.typeValue =
            params.get("sort") && params.get("sort") != "all"
                ? parseInt(params.get("sort"))
                : "all";

        let result = searchTypeList.some((el) => {
            return el.id == this.typeValue;
        });
        if (result) {
        } else {
            this.typeValue = "all";
        }

        this.typeValueCopy =
            params.get("sort") && params.get("sort") != "all"
                ? parseInt(params.get("sort"))
                : "all";
        // 初始化状态
        this.page = 1;
        this.isInit = true;
        this.hasMore = true;
        this.handleSearch();
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy() {
        // 移除滚动监听
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
        querySearchAsync(queryString, cb) {
            getSearchSuggestions(queryString, this.typeValue).then((response) => {
                if (response.status && response.status == "200" && response.data && response.data.status && response.data.status == "success") {
                    let result = response.data.data.suggestions.map((el) => {
                        return {
                            value: el.title,
                            url: el.url.replace("/zh-cn", ""),
                            label: el.title.replace(/<em>(.*?)<\/em>/g, "$1"),
                        };
                    });

                    let result2 = result.filter(item => {
                        // 检查 label 是否包含 words 中的任意一个词
                        const hasForbiddenWord = words.some(word =>
                            item.label.includes(word)
                        );
                        return !hasForbiddenWord; // 不包含才保留
                    })
                    cb(result2);
                } else {
                    cb([]);
                }
            }).catch((error) => {
                cb([]);
            });
        },
        handleEnterSearch() {
            // 重置状态
            this.page = 1;
            this.isInit = true;
            this.hasMore = true;
            this.handleSearch();
        },
        async handleSearch(isLoadMore = false) {
            if (!this.searchValue) {
                return;
            }
            
            // 如果是追加加载，检查状态
            if (isLoadMore && (this.loading || !this.hasMore)) {
                return;
            }
            
            // 如果不是追加加载且已经初始化过，直接返回
            if (!isLoadMore && !this.isInit) {
                return;
            }

            this.loading = true;
            
            try {
                const response = await getSearchResults(this.searchValue, this.typeValue, this.page);
                
                if (response.status && response.status == '200' && response.data.status && response.data.status == "success") {
                    let result = response.data.data.articles.map((el) => {
                        return {
                            ...el,
                            url: el.url.replace("/zh-cn", ""),
                            label: el.title.replace(/<em>(.*?)<\/em>/g, "$1"),
                                title: el.title.replace(/<em>(.*?)<\/em>/g, "$1"),
                                    excerpt: el.excerpt.replace(/<em>(.*?)<\/em>/g, "$1"),
                        };
                    });
                    
                    // 如果是追加加载，追加数据；否则替换数据
                    if (isLoadMore) {
                        this.list = [...this.list, ...result];
                        this.articles = [...this.articles, ...result];
                    } else {
                        this.list = result;
                        this.articles = result;
                        this.isInit = false;
                    }
                    console.log("this.list",this.list)
                    
                    
                    // 更新总数和是否有更多数据
                    const pagination = response.data.data.pagination || {};

                    console.log(response,pagination,this.total,this.hasMore)
                    this.total = pagination.total;
                    this.hasMore = pagination.has_next_page;
                } else {
                    // 请求失败
                    if (!isLoadMore) {
                        this.articles = [];
                        this.list = [];
                    }
                    this.hasMore = false;
                }
            } catch (error) {
                console.error('搜索失败:', error);
                if (!isLoadMore) {
                    this.articles = [];
                    this.list = [];
                }
                this.hasMore = false;
            } finally {
                this.loading = false;
            }
        },
        // 滚动到底部判断
        onScroll() {
            console.log("onScroll")
            // 节流：避免频繁触发
            if (this.loading || !this.hasMore || !this.searchValue) return;

            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = document.documentElement.scrollHeight;
            console.log("onScroll2")
            // 获取底部元素高度（如果存在）
            let footerHeight = 0;
            const footer = document.querySelector('.page-footer-wrapper');
            if (footer) {
                footerHeight = footer.offsetHeight;
            }

            // 判断是否接近底部（预留 200px 提前加载）
            if (scrollTop + clientHeight >= scrollHeight - 200 - footerHeight) {
                this.page += 1;
                this.handleSearch(true); // 标记为加载更多
            }
        },
        handleCurrentChange(page) {
            this.page = page;
            this.handleEnterSearch();
        },
    }
}
</script>

<style>
body {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.swiper-container {
    overflow: hidden;
}

.section1 {
    margin-top: 50rem;
}

.search-result-wrapper {
    margin-top: 32rem;
    display: flex;
    flex-wrap: wrap;
    gap: 34rem 19rem;
}

.search-result-card {
    position: relative;
    width: calc(25% - 15rem);
}

.search-result-card-img-box {
    /* width: 100%; */
    height: 169rem;
    overflow: hidden;
    border-radius: 8rem;
}

.search-result-card:hover .search-result-card-img {
    transform: scale(1.1);
}

.search-result-card-img {
    width: 100%;
    height: 169rem;
    border-radius: 8rem;
    background: #f9f6f2;
    overflow: hidden;
    object-fit: cover;
    transition: all 0.3s;
}

.search-result-card-title {
    margin-top: 22rem;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
    color: #232222;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.search-result-card-date {
    position: relative;
    margin-top: 12rem;
    color: #6a6967;
    font-size: 14rem;
    line-height: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-right: 40rem;
}

.search-result-card:hover .search-result-card-date::after {
    color: #6a6967;
}

.search-result-card-date::after {
    font-family: "iconfont" !important;
    content: "\e618";
    color: #fff;
    font-size: 16rem;
    position: absolute;
    right: 0;
    line-height: 21rem;
    transition: all 0.3s;
}

.ebc-page-pagination {
    display: flex;
    justify-content: center;
    margin-top: 50rem;
}

.load-more-tip {
    text-align: center;
    color: #999;
    font-size: 14rem;
    padding: 20rem 0;
}

.section2-title-box {
    margin-top: 88rem;
}

/* 直播课程 */
.webinars-box {
    position: relative;
}

.webinars-box .swiper-button-next {
    right: -40rem;

    color: #b2afad;
}

.webinars-box .swiper-button-prev {
    transform: rotate(180deg);
    left: -40rem;

    color: #b2afad;
}

.webinars-box .swiper-button-next:after {
    font-size: 28rem !important;
    font-family: "iconfont" !important;
    content: "\eb74";
}

.webinars-box .swiper-button-prev:after {
    font-size: 28rem !important;
    font-family: "iconfont" !important;
    content: "\eb74";
}

.webinars-list-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.swiper-slide {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.webinars-list {
    margin-top: 34rem;
}

.webinars-item {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    /* width: 100%; */
}

.webinars-item:hover::after {
    position: absolute;
    left: 0;
    bottom: -32rem;
    content: "";
    width: 100%;
    height: 1px;
    background-color: #a52933;
}

.webinars-item-img {
    width: 100%;
}

.webinars-item-title {
    margin-top: 25rem;
    color: #232222;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.webinars-item-time {
    margin-top: 12rem;
    color: #6a6967;
    font-size: 14rem;
    line-height: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-right: 40rem;
}

.webinars-item:hover .webinars-item-time::after {
    color: #6a6967;
}

.webinars-item-time::after {
    font-family: "iconfont" !important;
    content: "\e618";
    color: #fff;
    font-size: 16rem;
    position: absolute;
    right: 0;
    line-height: 21rem;
    transition: all 0.3s;
}

/* 直播课程结束 */
.no-data {
    display: flex;
    justify-content: center;
    padding: 80rem;
}

.no-data-img {
    width: 80rem;
}

@media (max-width: 996px) {
    .load-more-tip {
        font-size: 24rem;
    }
    .section1 {
        margin-top: 88rem;
    }

    .search-result-wrapper {
        gap: 48rem;
    }

    .search-result-card {
        width: 100%;
        display: flex;
        gap: 50rem;
    }

    .search-result-card-img {
        flex-shrink: 0;
        width: 264rem;
        height: 169rem;
        order: 1;
    }

    .search-result-card-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
    }

    .search-result-card-title {
        margin-top: 0;
        white-space: unset;
        font-size: 32rem;
        font-weight: 400;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .search-result-card-date {
        margin-top: 26rem;
        font-size: 28rem;
        line-height: 40rem;
    }

    .search-result-card-date::after {
        font-size: 28rem;
        line-height: 41rem;
    }

    .webinars-item-title {
        margin-top: 35rem;
        font-size: 32rem;
    }

    .webinars-item-time {
        margin-top: 25rem;
        font-size: 28rem;
        line-height: 40rem;
    }

    .webinars-item-time::after {
        font-size: 28rem;
        line-height: 41rem;
    }
}


.knowledge-list {
    /* margin-top: 48rem; */
    display: flex;
    flex-direction: column;
    gap: 40rem;
}

.knowledge-item {
    display: flex;
    justify-content: space-between;
    gap: 24rem;
}

.knowledge-item a {
    flex-shrink: 0;
}

.knowledge-item-content {
    position: relative;
    overflow: hidden;
    flex-grow: 1;
}

.knowledge-item-img {
    flex-shrink: 0;
    width: 160rem;
    /* height: 100rem; */
    object-fit: cover;
    border-radius: 8rem;
    background: #dadada;
}

.knowledge-item-title {
    width: 100%;
    color: #232222;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.knowledge-item-title:hover {
    color: #232222;
}

.knowledge-item-publish-time {
    margin-top: 4rem;
    color: #b2afad;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.knowledge-item-intro {
    margin-top: 12rem;
    color: #6a6967;

    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 996px) {
      .knowledge-list {
        /* margin-top: 74rem; */
        gap: 48rem;
    }

    .forex-title-intro {
        margin-top: 18rem;
    }

    .knowledge-item-img {
        width: 264rem;
        height: 169rem;
    }

    .knowledge-item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .knowledge-item-title {
        font-size: 32rem;
        white-space: unset;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .knowledge-item-publish-time {
        font-size: 28rem;
    }

    .knowledge-item-intro {
        display: none;
    }
}
</style>